<!--
 * @Author: wangzhu
 * @Date: 2021-12-29 16:27:33
 * @LastEditTime: 2022-12-29 19:24:16
 * @LastEditors: wangzhu10 wangzhu10@jd.com
-->
<template>
    <div id="page4-wrapper">
        <!-- <img class='left-start animate__animated  animate__pulse animate__infinite' src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-17-27JjW29DaoJHffAuvy.png"/> -->
        <!-- <img class='right-start' src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-11-05Rb9iQyRmcesWRHj.png"/> -->
        
        <!-- <img src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-21-18-4040pOeo12Fu749xziBr.png" class="title-image  animate__animated animate__fadeInRight"/> -->
        <div class="page4-content animate__animated animate__fadeInRight">
            
            <span>
                2023，你一共浏览了<br>
                <span class="report-num"> {{ reportData.viewPostNum }} </span>篇文章、
                <span class="report-num"> {{ reportData.viewChatNum }} </span>个畅聊<br>
                最常看的标签<span class="report-num-text"> {{ reportData.readMaxLabel }} </span><br>
                最常看的作者<span class="report-num-text"> {{ reportData.readMaxName }} </span><br>
                每一次满载收获的学习<br>
                都是技术的成长与进步<br>
            </span>
            <!-- <div class="page4-qa animate__animated animate__bounceInLeft">
                <div class="page-title">充满好奇</div>
                <span v-if="reportData.questionNum">
                    这一年你提出过<span class="report-num"> {{ reportData.questionNum }} </span>个问题<br>
                    有<span class="report-num"> {{ reportData.questionMan }} </span>个JDer和你有着同样的好奇<br>
                    有人不想变老就能一直年轻<br>
                    秘诀就是对这个世界永远好奇
                </span>
                <span v-else>
                    这一年社区共收到<span class="report-num"> {{ reportData.totalQuestion }} </span>个问题<br>
                    来自<span class="report-num"> {{ reportData.questionMan }} </span>个充满好奇的JDer<br>
                    有人不想变老就能一直年轻<br>
                    秘诀就是对这个世界永远好奇
                </span>
            </div> -->
            <!-- <div class="page-bg">
            </div> -->
            <!-- <div class="page4-coder animate__animated animate__bounceInRight">
                <div>
                    <div class="page-title">规范先锋</div>
                </div>
                <span v-if="reportData.goodCoders.length">
                    今年你完成理论学习、规范考试、代码实践<br>
                    通过<span v-for="(item, index) in reportData.goodCoders" :key="item">
                        <span class="report-num">{{ coder[item] }}</span>
                        <span v-if="index < reportData.goodCoders.length - 1" class="report-num">、</span>
                    </span>项目认证<br>
                    获得了<span class="report-num">GoodCoder</span>徽章<br>
                    优秀如你<br>
                    积极践行编码规范，共筑质量长城<br>
                </span>
                <span v-else>
                    为聚合京东代码文化<br>
                    通过理论学习、代码实践、规范考试<br>
                    助力提升京东研发代码质量<br>
                    今年已有<span class="report-num"> 191 </span>人学习了代码规范<br>
                    其中<span class="report-num"> {{ reportData.community.goodCoderCount }} </span>位小伙伴通过认证取得徽章<br>
                    明年加把劲徽章一定是你的~
                </span>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'Page4',
    props: {
        reportData: {
            required: true,
            default: () => {}
        },
    },
    data() {
        return {
            coder: {
                'java': 'JAVA',
                'anquan': '安全编码'
            }
        }
    },
    methods: {
        handleNext() {
            this.$emit('next');
        },
        handlePre() {
            this.$emit('pre');
        },
    },
};
</script>

<style lang="less" scoped>
#page4-wrapper {
    height: 100vh;
    width: 100%;
    padding: 0 20px;
    background-image: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-15-59jc28gmoG59QRfeWOE.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    .page4-content {
        // padding-top: 5vh;
        // padding: 36px 0 72px;
        font-size: 0.4rem;
        line-height: 2.8;
        font-weight: bold;
        color: #FAFAD7;
        // text-shadow: 1px 1px #19139B;
        position: relative;
        // background: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-11-52ZvU7afMyKhmFaq7.png');
        // background-size: 100% 100%;
        // width: 80%;
        margin: 3rem auto 0;
        border-radius: 8px;
        box-sizing: border-box;
        .page4-qa {
            text-align: left;
        }
        .page4-coder {
            margin-top: 40px;
            text-align: right;
            // display: flex;       
        }
    }
    .page-title {
        width: 100px;
        color: #fff;
        background: #2D97E1;
        border-radius: 4px;
        margin-bottom: 20px;
        font-weight: 500;
        line-height: 1;
        padding: 6px 0;
        position: relative;
        text-align: center;
        &:after {
            position: absolute;
            display: block;
            content: '';
            width: 300px;
            height: 4px;
            bottom: -4px;
            border-radius: 4px;
            background: #D9F0F9;
        }
    }
    .title-image {
        height: 1.3rem;
        margin-top: 10vh;
    }
    .report-num {
        color: #f1f406;
        font-weight: 500;
        font-size: 0.55rem;
    }
    .report-num-text {
       color: #f1f406;
        font-weight: 500;
        font-size: 0.45rem; 
    }
    .page-bg {
        background: #A7DEF8;
        width: 30px;
        height: 60px;
        position: absolute;
        top: 20px;
    }
    @keyframes rotoImg{
	from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    } 
	}
    .hourglass {
        animation: rotoImg 3s linear infinite;
        position: fixed;
        top: 5vh;
        left: 24px;
        width: 1.5rem;
        height: 1.5rem;
        z-index: 10;
    }
    .left-start {
        position: absolute;
        top: 5vh;
        left: 24px;
        width: 1.8rem;
        height: 1.8rem;
    }
    .right-start {
        position: absolute;
        top: 10vh;
        right: 24px;
        width: 1.5rem;
        height: 1.5rem;
    }
}
 @media screen and (min-width: 1980px) {
  #page4-wrapper {
    .page4-content {
        margin-top: 20vh;
    }
  }
}
</style>
